// extracted by mini-css-extract-plugin
module.exports = {"progress-ring":"progress-ring--2mr_O","circle":"circle--1hJoO","text":"text--LIYsS"};